import React, { useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Backdrop, CircularProgress } from '@material-ui/core'
import AuthPageShell from 'src/components/AuthPageShell'

import ResetPasswordForm from './ResetPasswordForm'
import { useParams, useHistory } from 'react-router'
import api from 'src/utils/api'
import Message from 'src/components/Message'
import { useTranslation } from 'react-i18next'
import ChangeLanguageButton from '../../components/ChangeLanguageButton'

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: 900
  }
}))

function ResetPasswordView () {
  const params = useParams()
  const classes = useStyles()
  const history = useHistory()

  const { t } = useTranslation('resetPasswordView')

  const { resetToken: token, email } = params

  const [loaderStatus, setLoaderStatus] = useState(false)
  const [hasResponse, setHasResponse] = useState(false)
  const [responseMessage, setResponseMessage] = useState('')
  const [isReady, setIsReady] = useState(false)

  const resetPassword = async (values) => {
    setLoaderStatus(true)
    const { password, confirmPassword } = values
    if (password && confirmPassword && token && email) {
      try {
        const body = { newPassword: password, email, token }
        await api.postResource('users', { path: '/resetPassword', body })
        setHasResponse('success')
        setResponseMessage(t('notifications.success'))
      } catch (e) {
        const errCode = e && e.response && e.response.data && e.response.data.error && e.response.data.error.statusCode
        setHasResponse('error')
        if (errCode === 404) {
          setResponseMessage(t('notifications.invalidLink'))
        } else {
          setResponseMessage(t('notifications.error'))
        }
      }
    }
    setLoaderStatus(false)
  }

  useState(() => {
    async function verifyToken () {
      try {
        await api.getResource('users', { path: `/resetPassword/validate?email=${email}&token=${token}` })
        setIsReady(true)
      } catch (e) {
        const errCode = e && e.response && e.response.data && e.response.data.error && e.response.data.error.statusCode
        setHasResponse('error')
        if (errCode === 404) {
          setResponseMessage(t('notifications.invalidLink'))
        } else {
          setResponseMessage(t('notifications.error'))
        }
        setIsReady(true)
      }
    }

    verifyToken()
  }, [email, token])

  if (!isReady) {
    return null
  }

  return (
    <AuthPageShell
      title={t('title')}
      heading={t('headerTitle')}
      actions={<ChangeLanguageButton useWhite={false} />}
      copyright={t('copyright', { actualYear: (new Date().getUTCFullYear()) })}
    >
      <Backdrop className={classes.backdrop} open={loaderStatus}>
        <CircularProgress color='primary' />
      </Backdrop>
      {hasResponse && hasResponse === 'success' ? <Message buttonText={t('buttons.login')} action={() => history.push('/auth/login')}>{responseMessage}</Message> : hasResponse && hasResponse === 'error' ? <Message>{responseMessage}</Message> : <ResetPasswordForm action={resetPassword} />}
    </AuthPageShell>)
}

export default ResetPasswordView
